<div id="error-dialog" style="display: flex; flex-direction: column; height: 100%; padding: 24px">

  <div *ngIf="hasErrors" class="row justify-content-center" align="center">
    <h1 class="display-5" [ngClass]="disallowSubmission ? 'margin-bottom: 0px;' : ''">Errors</h1>
  </div>

  <div *ngIf="disallowSubmission && hasErrors" class="row justify-content-center" align="center">
    <h4 class="display-5" style="font-style: italic">Fix to allow submission</h4>
  </div>

  <mat-divider *ngIf="hasErrors"></mat-divider>
  <br>

  <div *ngFor="let block of data.errors">
    <div *ngIf="block.isError">
      <br>
      <mat-card matRipple (click)="dialogRef.close(block.setIndex == -1 ? -1 : block.setID)">
        <mat-card-header style="color: #ff6f61;">
          <mat-card-title>{{block.title}}</mat-card-title>
        </mat-card-header>
        <mat-card-content>
          <ul *ngIf="block.isError" style="font-size: 16px;">
            <li *ngFor="let item of block.errorItems">
              {{item}}
            </li>
          </ul>
        </mat-card-content>

      </mat-card>
    </div>
  </div>

  <br>
  <br>

  <div class="row justify-content-center" align="center">
    <h1 class="display-5">Warnings</h1>
  </div>

  <mat-divider></mat-divider>
  <br>

  <div *ngFor="let block of data.errors">
    <div *ngIf="!block.isError">
      <mat-card matRipple (click)="dialogRef.close(block.setIndex == -1 ? -1 : block.setID)">
        <mat-card-header style="color: #ff6f61;">
          <mat-card-title>{{block.title}}</mat-card-title>
        </mat-card-header>
        <mat-card-content>
          <ul style="font-size: 16px;">
            <li *ngFor="let item of block.errorItems">
              {{item}}
            </li>
          </ul>
        </mat-card-content>
      </mat-card>
      <br>
    </div>
  </div>

  <!-- Back to Delivery -->
  <div *ngIf="!data.submission" class="row justify-content-end" style="margin-top: auto;">
    <button mat-fab
            class="text-button"
            type="button"
            (click)="dialogRef.close()">
      OK
    </button>
  </div>

  <div *ngIf="data.submission" class="row justify-content-between" style="margin-top: auto;">

    <div class="col-auto">
      <div class="row" style="padding-right: 10px;">
        <button mat-fab
                class="text-blue-button"
                type="button"
                (click)="dialogRef.close()">
          Cancel
        </button>
      </div>
    </div>

    <div class="col-auto text-right">
      <div class="row" style="padding-left: 10px;">
        <button mat-fab
                class="text-button"
                [disabled]="disallowSubmission"
                [style.opacity]="disallowSubmission ? '0.5' : '1'"
                type="button"
                (click)="dialogRef.close(-2)">
          OK
        </button>
      </div>
    </div>

  </div>


  <br>
</div>
